class DatacodeConfig {
    // static baseURL = "http://www.localhost:5000/api";
    // static baseURL = 'http://datacode-api.azurewebsites.net/api/'
    // static baseURL="https://datacode-api.onrender.com/api"
    static baseURL="https://datacode-api.vercel.app/api"
}

export default DatacodeConfig;